import React from 'react';
// import styles from './styles'

interface ToastWrapperProps{
  // add toast wrapper props here
  children : React.ReactNode;
  className?: string;

}

const ToastWrapper: React.FC<ToastWrapperProps> = ({
  className,
  children,
}: ToastWrapperProps) => {
  React.useEffect(() => {
    // console.log('Toast Wrapper added');
  }, []);
  return (
    <div className={`toast-wrapper ${className || ''}`}>
      { children }
    </div>
  );
};

ToastWrapper.defaultProps = {
  // add toast wrapper default props here
  className: null,
};

export default ToastWrapper;
